<template>
    <div class="modal fade" :id="unique" tabindex="-1" role="dialog" :aria-labelledby="`${unique}-title`" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" :class="`modal-${size}`">
            <div class="modal-content overflow-auto"
                 :style="{ minHeight: modalHeight ? `${modalHeight}px`: '', height: screenHeight ? '93vh': '' }"
            >
                <div class="modal-header">
                    <h6 class="modal-title font-weight-bolder" :id="`${unique}-title`">
                        {{ title }}
                    </h6>
                    <button type="button" :id="`close-${unique}`" class="close"
                            data-dismiss="modal" aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>


                <div class="modal-body text-small">
                    <slot></slot>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "CmsModal",

  props: {
    unique: {
      type: String,
      default() {
        return '';
      }
    },
    title: {
      type: String,
      default() {
        return '';
      }
    },
    size: {
      type: String,
      default() {
        return '';
      }
    },
    modalHeight: {
      type: Number,
      default() {
        return 0;
      }
    },
    screenHeight: {
      type: Boolean,
      default() {
        return false;
      }
    },

  }

}
</script>

<style scoped>

</style>